import { render, staticRenderFns } from "./amadeusaktarim.vue?vue&type=template&id=22063d82&"
import script from "./amadeusaktarim.vue?vue&type=script&lang=js&"
export * from "./amadeusaktarim.vue?vue&type=script&lang=js&"
import style0 from "./amadeusaktarim.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports